import React, { useEffect, useState } from "react";
import { getMenus } from "../../api/MenuService";
import { FaPlus, FaEye, FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { getErrorMessage } from "../../utils/errorHandler";

export default function MenuList() {
  const navigate = useNavigate();

  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("desc");

  const fetchMenus = async () => {
    try {
      setLoading(true);

      const res = await getMenus({
        search,
        sort,
      });
      const menuResponse = res?.data || res;

      const menuItems =
        menuResponse?.menus ||
        menuResponse?.menu ||
        menuResponse?.items ||
        menuResponse?.results ||
        menuResponse?.data ||
        menuResponse;

      const normalizedMenus = Array.isArray(menuItems)
        ? menuItems
        : menuItems?._id
          ? [menuItems]
          : [];

      setMenus(normalizedMenus);
    } catch (error) {
      console.error("Failed to fetch menus:", error);

      alert(getErrorMessage(error));

      setMenus([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMenus();
  }, [search, sort]);

  const handleView = (menu) => {
    navigate(`/menu/view/${menu._id}`, {
      state: {
        menuId: menu._id,
      },
    });
  };

  const handleEdit = (menu) => {
    navigate(`/menu/edit/${menu._id}`, {
      state: {
        menuId: menu._id,
      },
    });
  };

  return (
    <div className="container-fluid p-4 np-menu-page">
      {/* Header */}
      <div className="d-flex justify-content-end align-items-center mb-3">
        <div className="d-flex align-items-center gap-2">
          {/* Search */}
          <input
            type="text"
            className="form-control"
            placeholder="Search menu..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ width: "220px" }}
          />

          {/* Sort */}
          <select
            className="form-select border-0"
            value={sort}
            onChange={(e) => setSort(e.target.value)}
            style={{ width: "100px" }}
          >
            <option value="asc">ASC</option>
            <option value="desc">DESC</option>
          </select>

          {/* Add Menu */}
          <button
            type="button"
            className="btn btn-primary d-flex align-items-center gap-2"
            onClick={() => navigate("/menu/add")}
          >
            <FaPlus />
            Add Menu
          </button>
        </div>
      </div>

      {/* Loading */}
      {loading && (
        <div className="text-center py-4">
          <p className="mb-0">Loading menus...</p>
        </div>
      )}

      {/* Empty */}
      {!loading && menus.length === 0 && (
        <div className="text-center py-4">
          <p className="text-secondary mb-0">No menus found</p>
        </div>
      )}

      {/* Menu Table */}
      {!loading && menus.length > 0 && (
        <div className="card p-3">
          <div className="table-responsive">
            <table className="table table-bordered table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th className="text-dark fw-bold">#</th>
                  <th className="text-dark fw-bold">Name</th>
                  <th className="text-dark fw-bold">Slug</th>
                  <th className="text-dark fw-bold">Type</th>
                  <th className="text-dark fw-bold">Visible</th>
                  <th className="text-dark fw-bold">Order</th>
                  <th className="text-dark fw-bold">Parent</th>
                  <th className="text-dark fw-bold">Parent ID</th>
                  <th className="text-dark fw-bold">Status</th>
                  <th className="text-dark fw-bold">Actions</th>
                </tr>
              </thead>

              <tbody>
                {menus.map((menu, index) => (
                  <tr key={menu._id}>
                    <td>{index + 1}</td>

                    <td>{menu.name || "-"}</td>

                    <td>{menu.slug || "-"}</td>

                    <td>{menu.type || "-"}</td>

                    <td>{menu.visible ? "Yes" : "No"}</td>

                    <td>{menu.order ?? "-"}</td>

                    <td>{menu.parentId?.name || menu.parentId?.title || "No Parent"}</td>

                    <td>
                      {menu.parentId?._id ||
                        menu.parentId?.id ||
                        (typeof menu.parentId === "string" ? menu.parentId : "No Parent")}
                    </td>

                    <td>{menu.status || "Inactive"}</td>

                    <td>
                      <div className="d-flex justify-content-center gap-3">
                        <button
                          type="button"
                          className="border-0 bg-transparent p-0"
                          title="View"
                          onClick={() => handleView(menu)}
                        >
                          <FaEye size={18} color="black" />
                        </button>

                        <button
                          type="button"
                          className="border-0 bg-transparent p-0"
                          title="Edit"
                          onClick={() => handleEdit(menu)}
                        >
                          <FaEdit size={18} color="black" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
